<template>
    <div class="view-vertical">
        <div
                class="image-item"
                :class="{'vertical':item.is_vertical}"
                v-for="(item, index) in items"
                :key="item.id"
        >
            <div class="image-item__wrapper">
                <input class="image-item__checkbox" type="checkbox" :id="'id' + index" v-model="item.selected">
                <label class="image-item__label" :for="'id' + index"></label>
                <img
                        class="image-item__image"
                        :src="item.media.vertical || item.media.source"
                        :alt="item.title"
                >
                <span class="image-item__basket-sign"
                      v-if="showInBasketSign && item.in_basket"
                      :title="translations.media_in_basket"
                >
                {{ $root.$gettext('В корзине') }}
            </span>
            </div>
            <div class="image-item__description">
                <p><strong>ID:</strong> {{ item.id }}</p>
                <p><strong>{{ $root.$gettext('Название') }}:</strong> {{ item.title }}</p>
                <p><strong>{{ $root.$gettext('Описание') }}:</strong> {{ item.description }}</p>
                <p><strong>{{ $root.$gettext('Подпись') }}:</strong> {{ item.creator }}</p>
                <p><strong>{{ $root.$gettext('Снято') }}:</strong> {{ $root.getFormatedDate(item.created_at, 'date-with-long-month') }}, {{ item.place }}</p>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "ViewVertical",
        data() {
            return {
                translations: {
                    media_in_basket: 'Медиа находится в корзине',
                },
            }
        },
        props: {
            items: {
                type: Array,
                default: []
            },
            // Показывать ли отметку "В корзине"
            showInBasketSign: {
                type: Boolean,
                default: true,
            },
        },
    }
</script>

<style lang="scss" scoped>
    @import "resources/assets/scss/variables";

    .view-vertical {
        .image-item {
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: center;
            margin-bottom: 32px;
            &__wrapper {
                position: relative;
                display: flex;
                justify-content: flex-start;
                align-items: center;
                width: 888px;
                /*height: 591px;*/
                margin-bottom: 24px;
            }
            &__checkbox {
                position: absolute;
                opacity: 0;
                width: 0;
                height: 0;
                &:checked {
                    & + .image-item__label {
                        &:before {
                            background-color: $primaryColor;
                            border-color: $primaryColor;
                        }
                        &:after {
                            content: '';
                            position: absolute;
                            left: 12px;
                            top: 5px;
                            width: 6px;
                            height: 15px;
                            border: solid #fff;
                            border-width: 0 2px 2px 0;
                            transform: rotate(45deg);
                        }
                    }
                }
                &:focus {
                    & + .image-item__label {
                        &:before {
                            border-color: $primaryColor;
                        }
                    }
                }
            }
            &__label {
                padding: 0;
                cursor: pointer;
                position: absolute;
                left: 0;
                top: 0;
                &:before {
                    display: block;
                    content: '';
                    position: absolute;
                    top: 4px;
                    left: 4px;
                    width: 24px;
                    height: 24px;
                    background: #fff;
                    border: 1px solid $borderColor;
                    box-sizing: border-box;
                }
                &:hover {
                    &:before {
                        border: 1px solid $textSecondColor;
                    }
                }
            }
            &__image {
                width: 100%;
                height: auto;
            }
            &__basket-sign {
                position: absolute;
                display: block;
                bottom: 0;
                left: 0;
                background-color: $primaryColor;
                text-transform: uppercase;
                color: #fff;
                font-size: 12px;
                line-height: 1;
                padding: 6px 9px;
                font-family: 'Futura PT Demi';
            }
            &__description {

            }

            &.vertical {
                .image-item {
                    &__wrapper {
                        width: 444px;
                        height: 591px;
                    }
                    &__image {
                        width: auto;
                        height: 100%;
                    }
                }
            }
        }
    }
</style>
